'use client';

import { __makeTemplateObject } from '../../../../../_virtual/_tslib.js';
import styled, { css } from 'styled-components';
import styledCss from '../../../../../Utils/styledCss.js';

var LeftColumnContentWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: ", ";\n    max-height: 100%;\n    display: inline-block;\n    overflow-y: auto;\n    overflow-x: hidden;\n    ", ";\n    ", "\n"], ["\n    width: ", ";\n    max-height: 100%;\n    display: inline-block;\n    overflow-y: auto;\n    overflow-x: hidden;\n    ", ";\n    ", "\n"])), function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? '100%' : '50%');
}, styledCss.scrollbar, function (_a) {
    var isMobile = _a.isMobile;
    if (!isMobile) {
        return '';
    }
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            padding-bottom: 80px;\n            @supports (height: 100dvh) {\n                padding-bottom: 0;\n            }\n        "], ["\n            padding-bottom: 80px;\n            @supports (height: 100dvh) {\n                padding-bottom: 0;\n            }\n        "])));
});
var templateObject_1, templateObject_2;

export { LeftColumnContentWrapper };
//# sourceMappingURL=LeftColumnContent.css.js.map
